import { render, staticRenderFns } from "./RouteBuilderPage.vue?vue&type=template&id=bcd734e2&scoped=true&"
import script from "./RouteBuilderPage.vue?vue&type=script&lang=js&"
export * from "./RouteBuilderPage.vue?vue&type=script&lang=js&"
import style0 from "./RouteBuilderPage.vue?vue&type=style&index=0&id=bcd734e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd734e2",
  null
  
)

export default component.exports